// @mui material components
import { Card, CardActions, CardContent } from "@mui/material";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import StudentCard from "components/StudentCard";
import AttendanceInOutInptCard from "components/AttendanceInOutInptCard";

// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useRef, useState } from "react";
import MDSnackbar from "components/MDSnackbar";
import { checkInOut } from "framework/students/inout";

function StudentInOut() {
  const [studentData, setStudentData] = useState(null);
  const [isCheckingInOut, setIsCheckingInOut] = useState(false);
  const [snackbar, setSnackbar] = useState({
    desc: "",
    type: "success",
    icon: "check",
  });
  const studentCardRef = useRef();

  async function onInOutToggle() {
    const isIn = !studentData.isIn;
    setStudentData((prev) => ({
      ...prev,
      isIn: !prev.isIn,
    }));
    try {
      setIsCheckingInOut(true);
      await checkInOut(studentData, isIn);
      setSnackbar({
        desc: `Student successfully ${isIn ? "checked in" : "checked out"}`,
        type: "success",
        icon: "check",
      });
      setStudentData(null);
    } catch (err) {
      setStudentData((prev) => ({ ...prev, isIn: !prev.isIn }));
      setSnackbar({
        desc: `${isIn ? "Checkin" : "Checkout"} failed. ${err?.message ?? ""}`,
        type: "error",
        icon: "error",
      });
    } finally {
      setIsCheckingInOut(false);
    }
  }

  function closeSanckbar() {
    setSnackbar((prev) => ({ ...prev, desc: "" }));
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={5} mb={10}>
        <AttendanceInOutInptCard
          setStudentData={setStudentData}
          setSnackbar={setSnackbar}
          studentCardRef={studentCardRef}
        />
        {studentData && (
          <MDBox ref={studentCardRef}>
            <StudentCard
              {...studentData}
              onInOutToggle={onInOutToggle}
              isInOut={true}
              isCheckingInOut={isCheckingInOut}
            />
          </MDBox>
        )}
        <MDSnackbar
          color={snackbar.type}
          icon={snackbar.icon}
          title="AJCE Hostel Management"
          dateTime=""
          content={snackbar.desc}
          open={!!snackbar.desc}
          onClose={closeSanckbar}
          close={closeSanckbar}
          bgWhite
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default StudentInOut;
